import React from 'react';
import { PageBreakStoryblok } from '../../types/storyblok';
import { Box } from '../../base/Box/Box';
import classNames from 'classnames';
import * as Separator from '@radix-ui/react-separator';

export const PageBreak = ({
  smSpaceAbove = '0',
  mdSpaceAbove = '0',
  lgSpaceAbove = '0',
  smSpaceBelow = '0',
  mdSpaceBelow = '0',
  lgSpaceBelow = '0',
  colourScheme = 'white',
  overlayOverBkg,
}: PageBreakStoryblok) => {
  return (
    <Box
      as="section"
      colourScheme={colourScheme}
      bkg
      className={classNames(
        smSpaceAbove && smSpaceAbove !== '0' && `pt-${smSpaceAbove}`,
        mdSpaceAbove && mdSpaceAbove !== '0' && `md:pt-${mdSpaceAbove}`,
        lgSpaceAbove && lgSpaceAbove !== '0' && `lg:pt-${lgSpaceAbove}`,
        smSpaceBelow && smSpaceBelow !== '0' && `pb-${smSpaceBelow}`,
        mdSpaceBelow && mdSpaceBelow !== '0' && `md:pb-${mdSpaceAbove}`,
        lgSpaceBelow && lgSpaceBelow !== '0' && `sm:pb-${lgSpaceBelow}`
      )}
      blockSpacing
      overlayOverBkg={overlayOverBkg}
    >
      <Separator.Root
        orientation="horizontal"
        className="ff-divider border-b-none overlayOverBkg mx-auto max-w-wide border-t"
      />
    </Box>
  );
};

export default PageBreak;
